<template>
  <div class="card width-960">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <div class="center mgb-20px">
        <div class="columns">
          <div class="column">
            <h1 class="title is-size-4">
              {{ $t('listeEcheancesAPayer.popUpEditEcheancesAPayer.title') }}
            </h1>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'addEditCivilite.error.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <div class="columns is-multiline">
        <div class="column is-6">
          <div class="columns is-multiline">
            <qd-switch class="column is-narrow pdr-0 pdb-0"
                      v-model="updateValidateur" v-if="multiEcheanceAEdit">
            </qd-switch>
            <div class="column is-narrow pdb-0 has-text-default has-text-weight-bold"
            :class="{'pdl-0' : multiEcheanceAEdit}">
              {{ $t('listeEcheancesAPayer.popUpEditEcheancesAPayer.validateur') }}
            </div>
            <user-tag-input
              v-model="validateur"
              :disabled="!updateValidateur"
              msg-error="utilisateur.warning.validateursArchives"
              class="column is-12"
            />
          </div>
        </div>
        <div class="column is-6">
          <div class="columns is-multiline">
            <qd-switch class="column is-narrow pdr-0 pdb-0"
                      v-model="updateReferencePaiement" v-if="multiEcheanceAEdit">
            </qd-switch>
            <div class="column is-narrow pdb-0 has-text-default has-text-weight-bold"
                 :class="{'pdl-0' : multiEcheanceAEdit}">
              {{ $t('listeEcheancesAPayer.popUpEditEcheancesAPayer.refPaiement') }}
            </div>
            <b-input v-model="referencePaiement" class="column is-12"
                     expanded :disabled="!updateReferencePaiement">
            </b-input>
          </div>
        </div>
        <div class="column is-6">
          <div class="columns is-multiline">
            <qd-switch class="column is-narrow pdb-0 pdr-0"
                      v-model="updateCommentaire" v-if="multiEcheanceAEdit">
            </qd-switch>
            <div class="column is-narrow pdb-0 has-text-default has-text-weight-bold"
                 :class="{'pdl-0' : multiEcheanceAEdit}">
              {{ $t('listeEcheancesAPayer.popUpEditEcheancesAPayer.commentaire') }}
            </div>
            <b-input v-model="commentaire" class="column is-12"
                     expanded :disabled="!updateCommentaire">
            </b-input>
          </div>
        </div>
        <div class="column is-6">
          <div class="columns is-multiline">
            <qd-switch class="column is-narrow pdr-0 pdb-0"
                      v-model="updateBonAPayer" v-if="multiEcheanceAEdit">
            </qd-switch>
            <div class="column is-narrow pdb-0 has-text-default has-text-weight-bold"
                 :class="{'pdl-0' : multiEcheanceAEdit}">
              {{ $t('listeEcheancesAPayer.popUpEditEcheancesAPayer.bonAPayer') }}
            </div>
            <b-select v-model="bonAPayer" expanded class="column is-12"
                      :disabled="!updateBonAPayer">
              <option :value="true"> {{ $t('listeEcheancesAPayer.yes') }}
              </option>
              <option :value="false"> {{ $t('listeEcheancesAPayer.no') }}
              </option>
            </b-select>
          </div>
        </div>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('listeEcheancesAPayer.popUpEditEcheancesAPayer.actions.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="saveEcheancesAPayer()">
              {{ $t('listeEcheancesAPayer.popUpEditEcheancesAPayer.actions.validate')}}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { echeancierAPayerUpdate } from '@/api/echeancierContrat';
import validation from '@/services/validation/validation';
import translate from '@/services/baux/echeancesAPayer/translatorEcheancesAPayer';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import userTagInput from '@/components/commun/user/userTagInput';
import { echeanceAPayerUpdateSurFacture } from '@/api/mouvementClient/index';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    echeancesAPayer: {
      type: Array,
      required: true,
    },
    surFacture: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    errorMsgComponent,
    userTagInput,
  },
  data() {
    return {
      validateur: [],
      commentaire: '',
      referencePaiement: '',
      updateReferencePaiement: true,
      updateCommentaire: true,
      updateValidateur: true,
      updateBonAPayer: true,
      bonAPayer: true,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      echeancesAPayerIds: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    multiEcheanceAEdit() {
      return (this.echeancesAPayer.length > 1);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    async saveEcheancesAPayer() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const echeancesAPayer = [];
        this.echeancesAPayerIds.forEach((id) => {
          echeancesAPayer.push({
            echeancierId: id,
            validateur: this.validateur.map((v => {
              return v.id;
            })),
            commentaire: this.commentaire,
            bonAPayer: this.bonAPayer,
            referencePaiement: this.referencePaiement,
            updateBonAPayer: this.updateBonAPayer,
            updateValidateur: this.updateValidateur,
            updateReferencePaiement: this.updateReferencePaiement,
            updateCommentaire: this.updateCommentaire,
          });
        });
        if (this.surFacture) {
          echeancesAPayer.forEach((echeance) => {
            echeance.validateurs = cloneDeep(echeance.validateur);
            echeance.id = cloneDeep(echeance.echeancierId);
            delete echeance.validateur;
            delete echeance.echeancierId;
          });
          await echeanceAPayerUpdateSurFacture(echeancesAPayer);
        } else {
          await echeancierAPayerUpdate(echeancesAPayer);
        }
        this.$emit('updateOk', {
          validateur: this.validateur.map((v => {
            return v.id;
          })),
          commentaire: this.commentaire,
          bonAPayer: this.bonAPayer,
          referencePaiement: this.referencePaiement,
          updateBonAPayer: this.updateBonAPayer,
          updateValidateur: this.updateValidateur,
          updateReferencePaiement: this.updateReferencePaiement,
          updateCommentaire: this.updateCommentaire,
        });
        loadingComponent.close();
        this.$parent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          this.messages = [];
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.surFacture) {
        this.echeancesAPayerIds = this.echeancesAPayer.map((echeance) => {
          return echeance.id;
        });
      } else {
        this.echeancesAPayerIds = this.echeancesAPayer.map((echeance) => {
          return echeance.echeancierId;
        });
      }
      await this.loadParametreUtilisateur();
      if (!this.multiEcheanceAEdit) {
        this.commentaire = this.echeancesAPayer[0].commentaireLigneCommande;
        this.bonAPayer = this.echeancesAPayer[0].bonAPayer;
        this.referencePaiement = this.echeancesAPayer[0].referencePaiement;
        this.echeancesAPayer[0].validateur.forEach((validateurId) => {
          const userFind = this.parametre(PARAMETRES_KEYS.utilisateur).find((user) => {
            return user.id === validateurId;
          });
          if (userFind) this.validateur.push(userFind);
        });
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
